import { render } from "./ComboFormaPagamento.vue?vue&type=template&id=135a2b66&ts=true"
import script from "./ComboFormaPagamento.vue?vue&type=script&lang=ts"
export * from "./ComboFormaPagamento.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__